import { useCallback, useState, useMemo } from 'react';
import { getAssetTypeOptions, handleRealUsedFlag } from '@bingads-webui-campaign-react/asset-library-model';

export const useAssetTypeFilter = ({
  logger,
  i18n,
  preference,
  realUsedFlagSuffix,
}) => {
  const [assetTypeFilter, setAssetType] = useState(null);

  const assetTypeFilterOptions = useMemo(() => getAssetTypeOptions(i18n), [i18n]);

  const onAssetTypeChange = useCallback((newAssetType) => {
    if (assetTypeFilter !== newAssetType) {
      setAssetType(newAssetType);
      logger.logTrace('onAssetTypeChange', { assetTypeFilter: newAssetType });
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [logger, assetTypeFilter, preference, realUsedFlagSuffix]);

  return {
    assetTypeFilter,
    assetTypeFilterOptions,
    onAssetTypeChange,
  };
};
